var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container col-md-4 col-md-offset-3" },
    [
      _c("logo", { staticStyle: { "text-align": "center" } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      !_vm.authenticated
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-group",
                  staticStyle: { "margin-top": "40px", "margin-bottom": "30px" }
                },
                [
                  _c("div", { staticClass: "form-group input-group" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.username,
                          expression: "username"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "username",
                        type: "email",
                        placeholder: "Email"
                      },
                      domProps: { value: _vm.username },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.username = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group input-group" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: "password",
                        type: "password",
                        placeholder: "Password"
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "btn-default login-button",
                    attrs: { type: "submit" },
                    on: { click: _vm.submitLogin }
                  })
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "margin-top": "10px", "text-align": "center" } },
      [
        _vm._v("\n    This the login for the "),
        _c("strong", [_vm._v("Allied")]),
        _vm._v("Crowds Dashboard\n  ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white" }
      },
      [_c("i", { staticClass: "fa fa-envelope icon" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white" }
      },
      [_c("i", { staticClass: "fa fa-key icon" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beedb490", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beedb490","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginPage.vue
// module id = 151
// module chunks = 0